// Import components
import "../../components/material-toggle.js";
import "../../components/paper-options.js";
import "../../components/acryl-options.js";
import "../../components/aluminium-options.js";
import "../../components/gift-options.js";
import "../../components/wallable-watermark.js";

import "jquery-dropdown-datepicker";
import "@woocommerce/woocommerce-rest-api";
import "mapbox-gl/dist/mapbox-gl.css";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import html2canvas from "html2canvas";
import * as bootstrap from "bootstrap";
import momentsArchive from "./moments/moments-starmap.json";
import { Options } from "./options-starmap.js";
import { getShippingDate } from "./helpers/shipping-date.js";
import { resizePosterPreview } from "./helpers/resize-poster-preview.js";
import { getShoppingBagSummary } from "./helpers/shopping-bag-summary.js";
import { DebugReporter } from "./helpers/debug-reporter.js";
import { uploadProductScreenshot } from "./helpers/image-uploader.js";
import { initializeI18n } from "./i18n/initialize.js";
import { resolveCatalogProduct } from "./catalog/product-catalog.js";

mapboxgl.accessToken = process.env.MAPBOXTOKEN;
let woocommerceUrl = process.env.WOOCOMMERCE_URL || window.location.origin;
const apiBase = "";
const options = new Options();
let marketContext;
let t = (key) => key;
let formatCurrency = (value) => `€${Number(value).toFixed(2).replace(".", ",")}`;
let formatLocaleDate = (value) => String(value);

const i18nReady = initializeI18n().then((i18n) => {
  ({ marketContext, t, formatCurrency, formatDate: formatLocaleDate } = i18n);
  woocommerceUrl = marketContext.services.woocommerceBaseUrl;
});

const PosterColors = {
  1: {
    background: "#000000",
    starmap: "#000000",
    milkyway: "#ffffff",
    text: "#000000",
  },
  2: {
    background: "#8c031c",
    starmap: "#8c031c",
    milkyway: "#ffffff",
    text: "#4e0310",
  },
  3: {
    background: "#000d4f",
    starmap: "#000d4f",
    milkyway: "#ffffff",
    text: "#000d4f",
  },
  4: {
    background: "#00213f",
    starmap: "#00213f",
    milkyway: "#8EE8E3",
    text: "#00213f",
  },
  5: {
    background:
      "linear-gradient(to right bottom, rgba(41 76 198 / 1), rgba(35 60 142 / 1), rgba(4 14 43 / 1))",
    starmap: "#16308E",
    milkyway: "#ffffff",
    text: "#09184d",
  },
  6: {
    background: "#1f0252",
    starmap: "#1f0252",
    milkyway: "#ffffff",
    text: "#1f0252",
  },
  7: {
    background: "#867B6B",
    starmap: "#5f5444",
    milkyway: "#ffffff",
    text: "#5f5444",
  },
};

let PosterPreviewImage;
let ShowMobileSettingPanel = false;
let PrintTypeSelected = true;
const BuilderName = $("body").attr("id");

let SettingsPanel = options.get("settingsPanel", "map");
let PosterSize = options.get("posterSize", "small");
let PosterFrame = options.get("posterFrame", "black");
let AcrylBlock = options.get("acrylBlock", "black");
let AluminiumColor = options.get("aluminiumColor", "silver");
let PosterFontStyle = options.get("SongFontStyle", "modern");
let PrintType = options.get("printType", "paper");
let StarsMoment = options.get("StarsMoment");
let StarsDate = options.get("StarsDate", "2020-02-17");
let StarsTime = options.get("StarsTime", "22:30");
let StarsReadableDate = options.get("StarsReadableDate");
let StarsLocation = options.get("StarsLocation");
let StarsSubtitle = options.get("StarsSubtitle");
let StarsLat = options.get("StarsLat", "52.08");
let StarsLong = options.get("StarsLong", "4.32");
let ShowMilkyWay = options.get("ShowMilkyWay", true, "bool");
let ShowConstellations = options.get("ShowConstellations", true, "bool");
let ShowGlobe = options.get("ShowGlobe", false, "bool");
let ShowTime = options.get("ShowTime", true, "bool");
let PosterColorNumber = options.get("PosterColorNumber", "1");
let PosterBGColor = options.get("PosterBGColor", "light");
let PosterBorder = options.get("PosterBorder", "border");

StarsLat = parseFloat(StarsLat);
StarsLong = parseFloat(StarsLong);

const MomentSelector = $(".js-moments");
const MomentInput = $("#moment-input");
const MomentLabel = $(".labels .moment");
const CoordinatesInput = $("#coordinates-input");
const CoordinatesLabel = $(".labels .coordinates");
const SubtitleInput = $("#subtitle-input");
const SubtitleLabel = $(".labels .subtitle");
const Subtitle2Input = $("#subtitle-2-input");
const Subtitle2Label = $(".labels .subtitle-2");
const TimePicker = $("#timepicker");
const TimeToggle = $("#timeToggle");
const PosterWrapper = $(".map-wrapper");
const PosterSizeSelect = $(".js-poster-size");
const PosterFrameSelect = $(".js-poster-frame");
const AcrylBlockSelect = $(".js-acryl-block");
const PrintTypeSelect = $(".js-print-type");
const PosterGiftwrapSelect = $(".js-giftwrap");
const GiftCardSelect = $(".js-giftcard");
let GiftCardText = "";

const debugReporter = DebugReporter({
  ajaxUrl: apiBase + "/wp-json/wallable/v1/client-diagnostics",
  containerSelector: ".js-notifications",
  shouldShow: ({ meta }) =>
    meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
  extraContext: () => ({
    builder: $("body").attr("id"),
  }),
}).init();

// Load saved poster after locale and market configuration are available.
i18nReady.then(() => {
  getSavedPoster();
  toggleProductionEnv();
  calculatePosterPrice();
  resizePosterWrapper();
  toggleClearIcons();
  toggleStarmapOptions();
  setPreviewMode();
});

// For dismissing panel if previewing from shopping cart
function setPreviewMode() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("preview")) {
    dismissSettingsPanel();
  }
}

function waitForCelestial() {
  return new Promise((resolve, reject) => {
    if (window.Celestial) return resolve(window.Celestial);
    const t = setInterval(() => {
      if (window.Celestial) {
        clearInterval(t);
        resolve(window.Celestial);
      }
    }, 20);
    setTimeout(() => {
      clearInterval(t);
      reject(new Error("Celestial timeout"));
    }, 5000);
  });
}

$(async () => {
  const Celestial = await waitForCelestial();

  // Celestial stuff
  Celestial.display({
    width: 680,
    projection: "airy",
    container: "star-map",
    geopos: [StarsLat, StarsLong],
    disableAnimations: BuilderName === "PrintApp" ? true : false,
    datapath: "https://ofrohn.github.io/data/",
    controls: false,
    background: {
      fill: PosterColors[PosterColorNumber].starmap,
      opacity: 1,
      stroke: "none",
      width: 0.1,
    },
    stars: {
      show: true,
      limit: 6,
      names: false,
    },
    constellations: {
      names: false,
      lines: ShowConstellations,
    },
    planets: {
      names: false,
    },
    dsos: {
      names: false,
      show: false,
    },
    mw: {
      show: ShowMilkyWay,
      style: {
        fill: PosterColors[PosterColorNumber].milkyway,
        opacity: 0.15,
      },
    },
    lines: {
      graticule: {
        show: ShowGlobe,
        stroke: "#ffffff",
        width: 0.6,
        opacity: 0.8,
        lon: {
          pos: [""],
          fill: "#eee",
        },
        lat: {
          pos: [""],
          fill: "#eee",
        },
      },
      equatorial: { show: false },
      ecliptic: { show: false },
      galactic: { show: false },
      supergalactic: { show: false },
    },
  });

  Celestial.skyview({
    date: getCelestialDate(),
    location: [StarsLat, StarsLong],
    timezone: 60,
  });

  if (BuilderName !== "PrintApp") return;

  window.status = "mapbox-loading";

  await new Promise((r) => setTimeout(r, 5000));

  window.status = "mapbox-ready";
});

$(document).ready(async () => {
  await i18nReady;
  setTimeout(() => {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
    styleMilkyWay();
    applyColors(PosterColorNumber);
    setBGColor();
    toggleBorder();
    scaleFontSize();
    setPrintType(PrintType);
  }, "500");
});

// Geocoder stuff
let geocoder;
i18nReady.then(() => {
  geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    language: marketContext.locale.split("-")[0],
    placeholder: t("components.markerOptions.searchPlaceholder"),
  });

  geocoder.addTo("#geocoder");
  geocoder.on("result", (e) => {
    StarsLocation = formatCoordinates(e.result.center);
    StarsLat = e.result.center[1];
    StarsLong = e.result.center[0];
    Celestial.skyview({
      date: getCelestialDate(),
      location: [StarsLat, StarsLong],
      timezone: 60,
    });
  });
});

function formatCoordinates(lngLat) {
  function convertToDMS(deg) {
    const absolute = Math.abs(deg);
    const degrees = Math.floor(absolute);
    const minutes = Math.floor((absolute - degrees) * 60);
    const seconds = Math.round((absolute - degrees - minutes / 60) * 3600);
    return `${degrees}°${minutes}'${seconds}"`;
  }

  const lng = lngLat[0];
  const lat = lngLat[1];

  const latDirection = lat >= 0 ? "N" : "S";
  const lngDirection = lng >= 0 ? "E" : "W";

  const Coordinates = `${convertToDMS(lat)}${latDirection} ${convertToDMS(
    lng,
  )}${lngDirection}`;

  CoordinatesInput.val(Coordinates);
  CoordinatesLabel.html(Coordinates);
}

// For toggling starmap options
$(".js-toggle-starmap-option").on("click", function () {
  const toggle = $(this).data("starmap-option");
  switch (toggle) {
    case "ShowMilkyWay":
      ShowMilkyWay = ShowMilkyWay === true ? false : true;
      break;
    case "ShowConstellations":
      ShowConstellations = ShowConstellations === true ? false : true;
      break;
    case "ShowGlobe":
      ShowGlobe = ShowGlobe === true ? false : true;
      break;
    default:
  }
  toggleStarmapOptions();
  styleMilkyWay();
});

function toggleStarmapOptions() {
  $(
    '.js-toggle-starmap-option[data-starmap-option="ShowMilkyWay"]',
  ).toggleClass("active", ShowMilkyWay);
  $('.js-toggle-starmap-option[data-starmap-option="ShowGlobe"]').toggleClass(
    "active",
    ShowGlobe,
  );
  $(
    '.js-toggle-starmap-option[data-starmap-option="ShowConstellations"]',
  ).toggleClass("active", ShowConstellations);
}

// For Starmap colors
function applyColors(colorNumber) {
  $(".poster-canvas .labels").css({
    color: PosterColors[colorNumber].text,
  });
  Celestial.apply({
    background: {
      fill: PosterColors[colorNumber].starmap,
    },
    mw: {
      style: {
        fill: PosterColors[colorNumber].milkyway,
        opacity: 0.25,
      },
    },
  });
}

function loadColors() {
  // Target container where the elements will be appended
  const container = document.querySelector(".js-color-options-wrapper");

  // Loop through the PosterColors object and create elements
  Object.keys(PosterColors).forEach((key) => {
    const color = PosterColors[key];

    // Convert milkyway color to RGBA with opacity
    const milkywayRgba = hexToRgba(color.starmap, 0.9);

    // Create a div element
    const div = document.createElement("div");

    // Add classes and data attributes
    div.className = "js-style-option style-option color";
    div.dataset.style = key; // Set data-style="{array-index}"

    // Set background to a linear gradient
    div.style.background = `linear-gradient(35deg, ${milkywayRgba} 0%, ${milkywayRgba} 50%, ${color.starmap} 50%)`;

    // Append the div to the container
    container.appendChild(div);
  });
}

// Helper function to convert hex to RGBA with opacity
function hexToRgba(hex, opacity) {
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function styleMilkyWay() {
  Celestial.apply({
    mw: {
      show: ShowMilkyWay, // Show Milky Way as filled multi-polygon outlines
    },
    constellations: {
      lines: ShowConstellations,
    },
    lines: {
      graticule: {
        show: ShowGlobe,
        stroke: "#ffffff",
        width: 0.6,
        opacity: 0.8,
        // grid values: "outline", "center", or [lat,...] specific position
        lon: {
          pos: [""],
          fill: "#eee",
        },
        // grid values: "outline", "center", or [lon,...] specific position
        lat: {
          pos: [""],
          fill: "#eee",
        },
      },
    },
  });
}

// For border
$(".js-border-option").on("click", function () {
  PosterBorder = $(this).data("border");
  toggleBorderSelect();
  toggleBorder();
  dismissSettingsPanel();
});

function toggleBorderSelect() {
  $(".js-border-option").removeClass("active");
  if (PosterBorder === "no-border") {
    $('.js-border-option[data-border="no-border"]').addClass("active");
  } else {
    $('.js-border-option[data-border="border"]').addClass("active");
  }
}

function toggleBorder() {
  let showBorder;
  showBorder = PosterBorder === "no-border" ? true : false;
  $(".frame").toggleClass("d-none", showBorder);
}

// For background color
$(".js-bg-option").on("click", function () {
  PosterBGColor = $(this).data("bg");
  toggleBGColorSelect();
  setBGColor();
  dismissSettingsPanel();
});

function toggleBGColorSelect() {
  $(".js-bg-option").removeClass("active");
  if (PosterBGColor === "dark") {
    $('.js-bg-option[data-bg="dark"]').addClass("active");
  } else {
    $('.js-bg-option[data-bg="light"]').addClass("active");
  }
}

function setBGColor() {
  const border = $(".frame");
  const labels = $(".poster-canvas .labels");
  const canvas = $(".poster-canvas");
  canvas.attr("data-bg", PosterBGColor);
  if (PosterBGColor === "dark") {
    canvas.css({
      background: PosterColors[PosterColorNumber].background,
    });
    labels.css({ color: "#ffffff" });
    border.css({ "border-color": "#ffffff" });
    Celestial.apply({
      background: {
        stroke: "#ffffff",
        width: 3,
      },
    });
  } else {
    canvas.removeAttr("style");
    labels.css({ color: PosterColors[PosterColorNumber].text });
    border.css({ "border-color": PosterColors[PosterColorNumber].text });
  }
}

// For date selection
i18nReady.then(() => $("#datepicker").dropdownDatepicker({
  defaultDate: StarsDate,
  wrapperClass: "input-group mb-3",
  dropdownClass: "form-select",
  displayFormat: "ymd",
  yearLabel: t("starmap.date.year"),
  monthLabel: t("starmap.date.month"),
  dayLabel: t("starmap.date.day"),
  minYear: 1900,
  maxYear: 2030,
  monthLongValues: Array.from({ length: 12 }, (_, month) =>
    formatLocaleDate(new Date(2020, month, 1), { month: "long" }),
  ),
  daySuffixes: false,
  onChange: function (day, month, year) {
    if (day != null && month != null && year != null) {
      StarsDate = year + "-" + month + "-" + day;
      setReadableDateForPoster();
      Celestial.skyview({
        date: getCelestialDate(),
        location: [StarsLat, StarsLong],
        timezone: 60,
      });
    }
  },
}));

function formatPosterDate(dateString) {
  const [year, month, day] = dateString.split("-").map(Number);
  const FinalDay = day === 0 ? 1 : day;
  StarsReadableDate = formatLocaleDate(
    new Date(year, month - 1, FinalDay),
    { day: "numeric", month: "long", year: "numeric" },
  );

  if (ShowTime) {
    StarsReadableDate += `, ${StarsTime}`;
  }

  return StarsReadableDate;
}

function setReadableDateForPoster() {
  StarsReadableDate = formatPosterDate(StarsDate);
  SubtitleLabel.html(StarsReadableDate);
  SubtitleInput.val(StarsReadableDate);
}

// Time related stuff
function getCelestialDate() {
  const [y, m, d] = StarsDate.split("-").map(Number);
  const [hh, mm] = StarsTime.split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm, 0, 0);
}

TimePicker.on("blur", function () {
  StarsTime = $(this).val();
  setReadableDateForPoster();
  Celestial.skyview({
    date: getCelestialDate(),
    location: [StarsLat, StarsLong],
    timezone: 60,
  });
});

TimeToggle.on("change", function () {
  ShowTime = $(this).is(":checked");
  setTimeToggle();
  setReadableDateForPoster();
  Celestial.skyview({
    date: getCelestialDate(),
    location: [StarsLat, StarsLong],
    timezone: 60,
  });
});

function setTimeToggle() {
  const TimeInfoPanel = $(".js-time-info");
  if (ShowTime) {
    TimePicker.prop("disabled", false);
    TimeInfoPanel.addClass("d-none");
    StarsTime = TimePicker.val();
  } else {
    TimePicker.prop("disabled", true);
    TimeInfoPanel.removeClass("d-none");
    StarsTime = "00:00";
  }
}

// Change poster color
$(".js-color-options-wrapper").on("click", ".js-style-option", function () {
  PosterColorNumber = $(this).attr("data-style");
  applyColors(PosterColorNumber);
  setPosterColorSelection(PosterColorNumber);
  setBGColor();
});

function setPosterColorSelection(colorNumber) {
  var selectedColor = $('.js-style-option[data-style="' + colorNumber + '"]');
  $(".js-style-option").removeClass("active");
  selectedColor.addClass("active");
  dismissSettingsPanel();
}

// Input listeners
$("input.form-control, textarea.form-control").on("input", function () {
  const posterLabel = this.dataset.posterLabel;

  if (!posterLabel) return;

  const value = $(this).val();

  $(".labels ." + posterLabel).html(value);

  if (posterLabel === "moment") {
    scaleFontSize();
  }

  $('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(
    value.length > 0,
  );
});

$(".js-history-back").on("click", function () {
  history.back();
});

// Clear input fields
$(".js-clear-input").on("click", function () {
  const field = $(this).data("field-id");

  $(
    'input.form-control[data-poster-label="' +
      field +
      '"], ' +
      'textarea.form-control[data-poster-label="' +
      field +
      '"]',
  )
    .val("")
    .trigger("input")
    .trigger("focus");
});

// Check if field has value and show clear icon
function toggleClearIcons() {
  const inputFields = $("input.form-control");
  const textAreas = $("textarea.form-control");

  inputFields.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });

  textAreas.each(function () {
    const inputValue = $(this).val();

    if (inputValue.trim() === "") {
      let emptyField = $(this).data("poster-label");
      $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
    }
  });
}

// For scaling the font size
function scaleFontSize() {
  const minFontSize = 3.95;
  const maxFontSize = 6.45;
  const lineBreakThreshold = 3.96;
  const text = $(".js-poster-headline");
  const textWrapper = $(".headline-wrapper");
  const parentWidth = textWrapper[0].getBoundingClientRect().width;

  let fontSize =
    parseFloat(text.css("font-size")) /
    parseFloat(text.parent().css("font-size")); // Get current font size in em

  // Subpixel-precieze breedte van de tekst
  function getTextWidth() {
    return text[0].getBoundingClientRect().width;
  }

  // Check of tekst smaller is dan parent (met marge)
  function canGrow() {
    return getTextWidth() + 1 < parentWidth && fontSize < maxFontSize;
  }

  // Check of tekst te breed is
  function isTextTooWide() {
    return getTextWidth() > parentWidth - 1;
  }

  // Eerst verkleinen indien nodig
  while (isTextTooWide() && fontSize > minFontSize) {
    fontSize -= 0.05;
    text.css("font-size", fontSize + "em");
  }

  // Daarna vergroten tot het nét past
  while (canGrow()) {
    fontSize += 0.05;
    text.css("font-size", fontSize + "em");
  }

  // Als tekst erg klein wordt, laten wrappen
  if (fontSize <= lineBreakThreshold) {
    text.css("white-space", "pre-wrap");
    return; // Stop verdere schaalacties
  } else {
    text.css("white-space", "nowrap");
  }
}

// Changing poster
function setPosterSize(posterSize) {
  if (PrintType === "paper") {
    PosterWrapper.removeClass().addClass(
      "map-wrapper size-" + posterSize + " " + PrintType,
    );
  } else if (PrintType === "aluminium") {
    PosterWrapper.removeClass().addClass(
      "map-wrapper size-" + posterSize + " " + PrintType,
    );
  } else {
    PosterWrapper.removeClass().addClass("map-wrapper size-small " + PrintType);
  }
}

// Change poster font
$(".js-font-option").on("click", function () {
  PosterFontStyle = $(this).attr("data-font");
  setPosterFontSelection(PosterFontStyle);
  setPosterFontStyle(PosterFontStyle);
  dismissSettingsPanel();

  setTimeout(() => {
    scaleFontSize();
  }, 50);
});

function setPosterFontStyle(font) {
  $(".poster-canvas .labels").removeClass("modern classic mono");
  $(".poster-canvas .labels").addClass(font);
}

function setPosterFontSelection(font) {
  var selectedFont = $('.js-font-option[data-font="' + font + '"]');
  $(".js-font-option").removeClass("active");
  selectedFont.addClass("active");
}

// Change poster size
$(".js-size-option").on("click", function () {
  PosterSize = $(this).attr("data-size");
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
});

function setSizeSelection(posterSize) {
  let selectedSize = $(
    '.js-toggle-for-material[data-material="' +
      PrintType +
      '"] .js-size-option[data-size="' +
      posterSize +
      '"]',
  );

  $(".js-size-option").removeClass("active");
  selectedSize.addClass("active");

  if (PrintType !== "paper") return;

  let framePrice = 0;
  let frameNormalPrice = 0;
  switch (posterSize) {
    case "small":
      framePrice = 15;
      frameNormalPrice = 21.95;
      break;
    case "medium":
      framePrice = 20;
      frameNormalPrice = 24.95;
      break;
    case "large":
      framePrice = 35;
      frameNormalPrice = 39.95;
      break;
    default:
      framePrice = 0;
      frameNormalPrice = 0;
  }

  // If extra-large, force no frame
  if (posterSize === "extra-large") {
    PosterFrame = "no-frame";
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    $(".js-frame-option").addClass("disabled");
    $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
    $("small[frame-normal-price]").text("-");
    $("small[frame-price]").hide();
  } else {
    $(".js-frame-option").removeClass("disabled");
    $("small[frame-price]").show();
    $("small[frame-price]").text(formatCurrency(framePrice));
    $("small[frame-normal-price]").text(formatCurrency(frameNormalPrice));

    $(".js-frame-option")
      .not('[data-frame="no-frame"]')
      .attr("data-price", framePrice.toFixed(2));
  }
}

// Change print type
$(document).on("click", ".js-print-option", function () {
  let SelectedPrintType = $(this).attr("data-print");
  if (PrintType !== SelectedPrintType) {
    PrintType = SelectedPrintType;
    setPrintType(PrintType);
  }
  if ($(this).hasClass("d-block")) {
    PrintTypeSelected = true;
  }
  togglePrintTypes();
});

$(document).on("click", ".js-show-print-types", function () {
  togglePrintTypes();
});

function setPrintType(PrintType) {
  var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
  $(".js-print-option").removeClass("active");
  selectedPrint.addClass("active");

  // If acryl
  if (PrintType == "acryl") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "small";
    }
    if (PosterBGColor === "dark") {
      PosterBGColor = "light";
      setBGColor();
    }
    PosterFrame = "no-frame";

    // If aluminium
  } else if (PrintType == "aluminium") {
    if (PosterSize === "large" || PosterSize === "extra-large") {
      PosterSize = "medium";
    }
    if (PosterBGColor === "dark") {
      PosterBGColor = "light";
      setBGColor();
    }
    PosterFrame = "no-frame";
    setAluminiumColor(AluminiumColor);

    // If paper
  } else {
    if (PosterSize === "xs") {
      PosterSize = "small";
    } else if (PosterSize === "extra-large") {
      PosterSize = "large";
    }
    AcrylBlock = "no-block";
  }
  setAcrylBlock(AcrylBlock);
  setBlockSelection(AcrylBlock);
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  setPosterSize(PosterSize);
  setSizeSelection(PosterSize);
  calculatePosterPrice();
}

function togglePrintTypes() {
  if (PrintTypeSelected) {
    $(".js-print-option").hide();
    $(".js-toggle-for-material").hide();
    $(".js-show-print-types").show();
    $(".js-toggle-for-material[data-material*='" + PrintType + "']").show();
    $(".js-print-option[data-print='" + PrintType + "']").show();
    PrintTypeSelected = false;
  } else {
    $(".js-print-option").show();
    $(".js-show-print-types").hide();
    $(".js-toggle-for-material").hide();
    PrintTypeSelected = true;
  }
}

// Change aluminium color
$(".js-color-option").on("click", function () {
  AluminiumColor = $(this).attr("data-color");
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
});

function setAluminiumColor(color) {
  PosterWrapper.attr("data-aluminium-color", color);
}

function setAluminiumColorSelection(color) {
  var selectedColor = $('.js-color-option[data-color="' + color + '"]');
  $(".js-color-option").removeClass("active");
  selectedColor.addClass("active");
}

// Change acryl block
$(".js-block-option").on("click", function () {
  AcrylBlock = $(this).attr("data-block");
  setBlockSelection(AcrylBlock);
  setAcrylBlock(AcrylBlock);
  calculatePosterPrice();
});

function setBlockSelection(AcrylBlock) {
  var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
  $(".js-block-option").removeClass("active");
  selectedBlock.addClass("active");
}

function setAcrylBlock(AcrylBlock) {
  $(".aluminium-stand").hide();
  $(".acryl-block").show();
  PosterWrapper.attr("data-perspective", false);
  if (AcrylBlock == "black") {
    $(".acryl-block").removeClass("d-none oak").addClass("black");
    PosterWrapper.attr("data-perspective", true);
  } else if (AcrylBlock == "oak") {
    $(".acryl-block").removeClass("d-none black").addClass("oak");
    PosterWrapper.attr("data-perspective", true);
  } else {
    $(".acryl-block").removeClass("oak black").addClass("d-none");
  }
}

// Change poster frame
$(".js-frame-option").on("click", function () {
  PosterFrame = $(this).attr("data-frame");
  setFrameSelection(PosterFrame);
  setPosterFrame(PosterFrame);
  calculatePosterPrice();
});

function setPosterFrame(PosterFrame) {
  const frameElement = $(".poster-frame");
  const frameClasses = ["black-frame", "oak-frame", "white-frame"];

  frameElement.removeClass(frameClasses.join(" ") + " d-none");

  if (frameClasses.includes(PosterFrame + "-frame")) {
    frameElement.addClass(PosterFrame + "-frame");
  } else {
    frameElement.addClass("d-none");
  }
  activateGiftwrap();
}

function setFrameSelection(frame) {
  var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
  $(".js-frame-option").removeClass("active");
  selectedFrame.addClass("active");
}

// Get list of moments
function loadMoments() {
  momentsArchive.moments.forEach((_moment, index) => {
    const label = index === 0
      ? t("starmap.defaults.customMoment")
      : t(`starmap.moments.${index}`);
    MomentSelector.append(
      `<option value="${label}">${label}</option>`,
    );
  });
}

MomentSelector.on("change", function () {
  let moment = $(this).val();
  if (moment === t("starmap.defaults.customMoment")) {
    MomentInput.val(t("starmap.defaults.event"));
    MomentLabel.html(t("starmap.defaults.event"));
  } else {
    MomentInput.val(moment);
    MomentLabel.html(moment);
  }
  scaleFontSize();
});

// Toggle giftwrap
$(".js-giftwrap").on("change", function () {
  calculatePosterPrice();
});

function activateGiftwrap() {
  if (PrintType === "paper" && PosterFrame === "no-frame") {
    PosterGiftwrapSelect.val("false");
    $(".js-giftwrap option[value=true]")
      .attr("disabled", "disabled")
      .siblings()
      .removeAttr("disabled");
  } else {
    $(".js-giftwrap option[value=true]").removeAttr("disabled");
  }
}

// Change giftcard text
$(".js-giftcard").on("change", function () {
  if ($(this).val() === "true") {
    $(".js-giftcard-text").show();
    GiftCardText = $(".js-giftcard-text").val();
  } else {
    $(".js-giftcard-text").hide();
    GiftCardText = "";
  }
  calculatePosterPrice();
});

$(".js-giftcard-text").on("change", function () {
  GiftCardText = $(this).val();
});

// Calculate poster price
function calculatePosterPrice() {
  const getPrice = (selector) =>
    parseFloat($(selector).find(".active, :selected").attr("data-price")) || 0;

  const subtotalPrice =
    getPrice(PosterSizeSelect) +
    getPrice(AcrylBlockSelect) +
    getPrice(PosterFrameSelect) +
    getPrice(PosterGiftwrapSelect) +
    getPrice(GiftCardSelect);

  $(".subtotal").html(formatCurrency(subtotalPrice));
}

// Create poster preview image
function createPosterPreview() {
  $(".poster-frame, .block-wrapper").addClass("hidden");
  $(".map-wrapper").addClass("shadow-none");
  const element = document.querySelector(".poster-wrapper");

  html2canvas(element, {
    scale: window.devicePixelRatio || 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  }).then((canvas) => {
    PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
    $(".js-poster-preview").attr("src", PosterPreviewImage);
  });
  $(".map-wrapper").removeClass("shadow-none");
  $(".poster-frame, .block-wrapper").removeClass("hidden");
}

// For hiding some unnecessary fields on staging
function toggleProductionEnv() {
  if (process.env.OAK_FRAMES === "false") {
    $('[data-frame="oak"]').remove();
  }
  if (process.env.ACRYL_PRODUCTS === "false") {
    if (PrintType === "acryl") {
      PrintType = "paper";
      PosterWrapper.removeClass("acryl");
    }
    $(".js-show-for-acryl").remove();
    $(".js-hide-for-acryl").show();
    $(".js-material-toggle [data-print='acryl']").remove();
  }
  if (process.env.ALUMINIUM_PRODUCTS === "false") {
    if (PrintType === "aluminium") {
      PrintType = "paper";
      PosterWrapper.removeClass("aluminium");
    }
    $(".js-show-for-aluminium").remove();
    $(".js-hide-for-aluminium").show();
    $(".js-material-toggle [data-print='aluminium']").remove();
  }
}

// For saving design to local storage
function saveDesign() {
  localStorage.setItem("posterSize", PosterSize);
  localStorage.setItem("posterFrame", PosterFrame);
  localStorage.setItem("StarsMoment", MomentLabel.html());
  localStorage.setItem("StarsDate", StarsDate);
  localStorage.setItem("StarsTime", StarsTime);
  localStorage.setItem("StarsLat", StarsLat);
  localStorage.setItem("StarsLong", StarsLong);
  localStorage.setItem("StarsLocation", CoordinatesLabel.html());
  localStorage.setItem("StarsReadableDate", SubtitleLabel.html());
  localStorage.setItem("StarsSubtitle", Subtitle2Label.html());
  localStorage.setItem("SongFontStyle", PosterFontStyle);
  localStorage.setItem("printType", PrintType);
  localStorage.setItem("acrylBlock", AcrylBlock);
  localStorage.setItem("aluminiumColor", AluminiumColor);
  localStorage.setItem("ShowMilkyWay", ShowMilkyWay);
  localStorage.setItem("ShowConstellations", ShowConstellations);
  localStorage.setItem("ShowGlobe", ShowGlobe);
  localStorage.setItem("ShowTime", ShowTime);
  localStorage.setItem("PosterColorNumber", PosterColorNumber);
  localStorage.setItem("PosterBGColor", PosterBGColor);
  localStorage.setItem("PosterBorder", PosterBorder);
}

// For getting design from local storage or parameters
function getSavedPoster() {
  // Prepare text labels
  if (BuilderName !== "PrintApp") {
    if (options.get("StarsMoment") !== null) {
      StarsMoment = options.get("StarsMoment");
    } else {
      StarsMoment = t("starmap.fields.moment");
    }

    if (options.get("StarsLocation") !== null) {
      StarsLocation = options.get("StarsLocation");
    } else {
      StarsLocation = `52°22'40.8"N 4°54'0.0"E`;
    }

    if (options.get("StarsReadableDate") !== null) {
      StarsReadableDate = options.get("StarsReadableDate");
    } else {
      StarsReadableDate = formatPosterDate(StarsDate);
    }
    loadMoments();
    loadColors();
    setPosterColorSelection(PosterColorNumber);
    toggleBGColorSelect();
    toggleBorderSelect();
    TimePicker.val(StarsTime);
    setTimeToggle();
    TimeToggle.prop("checked", ShowTime);
  } else {
    StarsMoment = options.get("StarsMoment");
    StarsLocation = options.get("StarsLocation");
    StarsReadableDate = options.get("StarsReadableDate");
  }

  // Set text labels
  MomentLabel.html(StarsMoment);
  MomentInput.val(StarsMoment);
  CoordinatesLabel.html(StarsLocation);
  CoordinatesInput.val(StarsLocation);
  SubtitleLabel.html(StarsReadableDate);
  SubtitleInput.val(StarsReadableDate);
  Subtitle2Label.html(StarsSubtitle);
  Subtitle2Input.val(StarsSubtitle);
  TimePicker.val(StarsTime);

  if (PrintType !== "acryl" && PrintType !== "aluminium") {
    if (PosterSize === "xs") {
      PosterSize = "small";
    }
    if (PrintType === "framed-poster" || PrintType === "tegel") {
      PrintType = "paper";
    }
  }
  setPosterSize(PosterSize);
  setAluminiumColor(AluminiumColor);
  setAluminiumColorSelection(AluminiumColor);
  $(".js-toggle-for-material").hide();
  togglePrintTypes();
  PosterFrameSelect.val(PosterFrame);
  PrintTypeSelect.val(PrintType);

  setPosterFontStyle(PosterFontStyle);
  setPosterFontSelection(PosterFontStyle);
}

// Resize canvas
$(window).resize(function () {
  resizePosterWrapper();
});

function resizePosterWrapper() {
  resizePosterPreview();
}

window.visualViewport?.addEventListener("resize", resizePosterWrapper);

// Toggle settings panels
$(".js-settings-toggle").on("click", function () {
  var target = $(this).attr("data-target");
  $(".nav-link").removeClass("active");
  $(".nav-link[data-target=" + target + "]").addClass("active");

  if (ShowMobileSettingPanel == false) {
    $(".side-nav").addClass("shown");
    ShowMobileSettingPanel = true;
  }

  if (target === SettingsPanel) {
    return;
  }
  $(".settings-panel").addClass("d-none");
  $(".settings-panel." + target).removeClass("d-none");
  $(".nav-pills .nav-link").removeClass("active");
  $("#pills-" + target + "-tab").addClass("active");

  if (target == "shop" && SettingsPanel !== "shop") {
    setPosterSummary();
  }

  $(".options-container").scrollTop(0);
  SettingsPanel = target;
  saveDesign();
});

$(".js-close-settings").on("click", function () {
  dismissSettingsPanel();
});

function dismissSettingsPanel() {
  $(".side-nav").removeClass("shown");
  ShowMobileSettingPanel = false;
}

// Prepping shopping cart
function setPosterSummary() {
  getShoppingBagSummary(PosterSize, PrintType, PosterFrame, AcrylBlock, t);
  $(".js-shipping-date").html(
    getShippingDate({ t, formatDate: formatLocaleDate }),
  );
  createPosterPreview();
}

function getProductVariation() {
  const variationKey = PrintType === "paper" ? `${PosterSize}-${PosterFrame}` : PosterSize;
  const product = resolveCatalogProduct(marketContext.catalog, "starmap", PrintType, variationKey);
  return { id: product?.id ?? null, variation_id: product?.variationId ?? null };
}

function isPrintApp() {
  return $("html").hasClass("PrintApp");
}

// Adding poster to cart
$(".js-save-poster").on("click", async function () {
  saveDesign();
  let ProductID = getProductVariation();

  $(this)
    .html(
      `${t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`,
    )
    .prop("disabled", true);

  let thumbnailUrl;
  try {
    thumbnailUrl = await uploadProductScreenshot(
      PosterPreviewImage,
      BuilderName,
    );
  } catch (error) {
    console.error("Product screenshot kon niet worden opgeslagen", error);
    $(this).html(t("actions.addToCart")).prop("disabled", false);
    $(".js-notifications").append(
      `<div class="js-error alert alert-danger text-center p-2">${t("sportsmap.errors.saveFailed")}</div>`,
    );
    return;
  }

  let payload = {
    "add-builder-item-to-cart": true,
    edit_url: woocommerceUrl + "/builder/starmap-poster/?preview",
    thumbnail: thumbnailUrl,
    product_id: ProductID.id,
    variation_id: ProductID.variation_id,
    poster: {
      printType: PrintType,
      size: PosterSize,
      giftwrap: PosterGiftwrapSelect.val(),
      giftcardText: GiftCardText,
      StarsMoment: localStorage.getItem("StarsMoment"),
      StarsLocation: localStorage.getItem("StarsLocation"),
      StarsReadableDate: localStorage.getItem("StarsReadableDate"),
      StarsSubtitle: localStorage.getItem("StarsSubtitle"),
      StarsLat: localStorage.getItem("StarsLat"),
      StarsLong: localStorage.getItem("StarsLong"),
      StarsDate: localStorage.getItem("StarsDate"),
      StarsTime: localStorage.getItem("StarsTime"),
      ShowMilkyWay: localStorage.getItem("ShowMilkyWay"),
      ShowConstellations: localStorage.getItem("ShowConstellations"),
      ShowGlobe: localStorage.getItem("ShowGlobe"),
      ShowTime: localStorage.getItem("ShowTime"),
      SongFontStyle: localStorage.getItem("SongFontStyle"),
      ...(["aluminium"].includes(PrintType) && {
        aluminiumColor: localStorage.getItem("aluminiumColor"),
      }),
      ...(["aluminium", "acryl", "tegel"].includes(PrintType) && {
        acrylBlock: localStorage.getItem("acrylBlock"),
      }),
      ...(["paper"].includes(PrintType) && {
        frame: PosterFrame,
      }),
      PosterColorNumber: localStorage.getItem("PosterColorNumber"),
      PosterBGColor: localStorage.getItem("PosterBGColor"),
      PosterBorder: localStorage.getItem("PosterBorder"),
      main: localStorage.getItem("StarsMoment"),
      subtitle: localStorage.getItem("StarsLocation"),
      subtitle2: localStorage.getItem("StarsSubtitle"),
    },
    pdf: {
      type: "starmap",
      print:
        PrintType === "paper" && PosterFrame !== "no-frame"
          ? "framed-poster"
          : PrintType,
    },
  };

  // console.log("Payload: ", payload);

  let action =
    process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";
  const endpoint = apiBase + "/wp-json/wallable/v1/" + action;
  let didRetryAsForm = false;

  const runAjax = (useFormEncoding = false) => {
    return $.ajax({
      url: endpoint,
      type: "POST",
      timeout: 20000,

      ...(useFormEncoding
        ? {
            data: { payload: JSON.stringify(payload) },
          }
        : {
            contentType: "application/json",
            data: JSON.stringify(payload),
          }),

      error: (jqXHR, textStatus, errorThrown) => {
        if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
          didRetryAsForm = true;
          return runAjax(true);
        }

        console.error(jqXHR, textStatus, errorThrown);

        setTimeout(() => {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-error alert alert-danger text-center p-2">${t("errors.generic")}</div>`,
            );
          }

          debugReporter.show({
            meta: { action, didRetryAsForm },
            request: {
              url: endpoint,
              method: "POST",
              mode: useFormEncoding ? "form" : "json",
              origin: window.location.origin,
              woocommerceUrl,
              online: navigator.onLine,
              visibilityState: document.visibilityState,
            },
            response: {
              status: jqXHR?.status,
              statusText: jqXHR?.statusText || textStatus,
              thrownError: errorThrown ? String(errorThrown) : null,
              responseText: (jqXHR?.responseText || "").slice(0, 4000),
            },
          });

          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }, 500);
      },

      success: () => {
        if (action === "add-to-cart") {
          $(this).html(t("actions.addToCart")).prop("disabled", false);

          window.location = woocommerceUrl + "/cart/";
        } else {
          if (!$(".js-notifications").find(".js-error").length) {
            $(".js-notifications").append(
              `<div class="js-success alert alert-success text-center p-2">&#x2713; ${t("actions.posterAdded")}</div>`,
            );
          }
          $(this).html(t("actions.addToCart")).prop("disabled", false);
        }
      },
    });
  };

  runAjax(false);
});

// Tooltips
if (!isPrintApp()) {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}
